<template>
  <div :title="$t('sectionModalBudget.viewAllContactQuotes')">
    <button
      type="button"
      class="btn-square btn-secondary btn-rounded"
      @click="AbrirModal()"
    >
      <i class="fas fa-shopping-cart"></i>
    </button>

    <b-modal
      v-model="abrir"
      size="lg"
      :title="$t('sectionModalBudget.contactQuotes')"
      hide-footer
    >
      <div class="row">
        <div class="col">
          <label for="">
            {{ $t("sectionModalBudget.changeBudgetStatus") }}
          </label>
        </div>
      </div>
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <div v-else>
        <b-table
          :hover="true"
          responsive
          :items="itens"
          :fields="fields"
          striped
          :per-page="itensPorPagina"
          show-empty
          :empty-text="$t('sectionModalBudget.quoteNotFound')"
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(data)="data">
            <div class="center">
              <label for>{{ new Date(data.item.data).toLocaleString() }}</label>
            </div>
          </template>
          <template v-slot:cell(origem)="data">
            <div class="center">
              <span class="badge">{{ ObterOrigemNome(data.item.origem) }}</span>
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <div class="center">
              <span :class="ObterBadgeStatus(data.item.status)">{{
                ObterStatusNome(data.item.status)
              }}</span>
            </div>
          </template>
          <template v-slot:cell(valor)="data">
            <div class="center">
              <label for="">R$ {{ data.item.valor }}</label>
            </div>
          </template>
          <template v-slot:cell(acoes)="data">
            <div class="btn-group-sm">
              <a
                class="btn-square-sm btn-secondary btn-rounded mr-2"
                :href="'#/orcamento/editar/' + data.item.id"
                :title="$t('sectionModalBudget.viewQuote')"
                target="_blank"
              >
                <i class="fas fa-eye text-black"></i>
              </a>
            </div>
          </template>
        </b-table>
        <b-pagination
          v-model="pagina"
          :total-rows="total"
          :per-page="itensPorPagina"
          align="right"
          size="md"
          class="mt-2"
        ></b-pagination>
      </div>
    </b-modal>
  </div>
</template>

<script>
import OrigemOrcamento from "../../enums/OrigemOrcamento";
import StatusOrcamento from "../../enums/StatusOrcamento";
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "ModalBudget",
  components: {
    RotateSquare
  },
  props: {
    contatoId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      abrir: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 0
    };
  },
  computed: {
    fields() {
      return [
        { key: "integracaoId", label: this.$t("textNumero"), sortable: true },
        {
          key: "data",
          label: this.$t("sectionEmail.emailData"),
          sortable: true
        },
        {
          key: "usuarioCadastro",
          label: this.$t("sectionAttendance.attendant"),
          sortable: true
        },
        {
          key: "origem",
          label: this.$t("sectionOrcamento.orcamentoOrigem"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("sectionOrcamento.orcamentoStatus"),
          sortable: true
        },
        {
          key: "valor",
          label: this.$t("sectionOrcamento.orcamentoValor"),
          sortable: true
        },
        {
          key: "acoes",
          label: this.$t("sectionOrcamento.orcamentoAcao"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  methods: {
    AbrirModal() {
      this.abrir = true;
      this.ObterGrid(1);
    },
    ObterBadgeStatus(status) {
      switch (status) {
        case StatusOrcamento.Pendente:
          return "badge badge-secondary";
        case StatusOrcamento.Processando:
          return "badge badge-primary";
        case StatusOrcamento.Calculado:
          return "badge badge-warning";
        case StatusOrcamento.Cancelado:
          return "badge badge-danger";
        case StatusOrcamento.Confirmado:
          return "badge badge-success";
        default:
          return "badge badge-dark";
      }
    },
    ObterStatusNome(status) {
      switch (status) {
        case StatusOrcamento.Pendente:
          return this.$t("textPendente");
        case StatusOrcamento.Processando:
          return this.$t("textProcessando");
        case StatusOrcamento.Calculado:
          return this.$t("textCalculado");
        case StatusOrcamento.Cancelado:
          return this.$t("textCancelado");
        case StatusOrcamento.Confirmado:
          return this.$t("textConfirmado");
        default:
          return this.$t("textNenhum");
      }
    },
    ObterOrigemNome(tipo) {
      switch (tipo) {
        case OrigemOrcamento.WhatsApp:
          return "WhatsApp";
        case OrigemOrcamento.Email:
          return this.$t("sectionLogin.email");
          case OrigemOrcamento.Instagram:
          return "Instagram";
          case OrigemOrcamento.Messenger:
          return "Facebook";
        default:
          return this.$t("textNenhum");
      }
    },
    ObterGrid(pagina) {
      this.loading = true;
      let filtro = {
        Pagina: pagina,
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        ContatoId: this.contatoId,
        ItensPorPagina: 5
      };
      this.$http({
        url: "/orcamento/obter-grid/",
        data: filtro,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style lang="scss"></style>
